/* eslint-disable jsx-a11y/img-redundant-alt */
import React from "react";

const WorkItems = ({ item }) => {
  return (
    <div className="work__card" key={item.id}>
      <img src={item.image} alt={`${item.title} cover`} className="work__img" />
      <h3 className="work__title">{item.title}</h3>
      <p className="work__title2">{item.description}</p>
      {item.technologies?.length && (
        <div className="work__subtitle">
          Technologies used:<br/>
          {item.technologies.map((technology, i) => (
            <span key={i}>
              {technology}
              {i < item.technologies.length - 1 && ", "}
            </span>
          ))}
        </div>
      )}
      <a href={item.demo} target="_blank" className="work__button" rel="noreferrer">
        Demo <i className="bx bx-right-arrow-alt work__button-icon"></i>
      </a>
    </div>
  );
};

export default WorkItems;
